// "use client";
// import React from 'react';
// import { FloatingDock } from '../ui/floating-dock';
// import { 
//     FaPaypal,
//     FaBtc,
//     FaRupeeSign,
//     FaCoffee,
//  } from "react-icons/fa";
// import { RiTelegramLine } from "react-icons/ri";
// import { SiGithubsponsors } from "react-icons/si";
// import { BackgroundGradient } from '../ui/background-gradient';
// // import { BackgroundBeamsWithCollision } from '../ui/background-beams-with-collision';

// const SponsorPage = () => {
//   const links = [
//     {
//       title: "Donate via UPI",
//       icon: <FaRupeeSign className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "/upi",
//     },
//     {
//       title: "Donate via GitHub Sponsors",
//       icon: <SiGithubsponsors className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "https://github.com/sponsors/MrAbhi2k3",
//     },
//     {
//       title: "Donate via Bitcoin",
//       icon: <FaBtc className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "/crypto",
//     },
//     {
//       title: "Thank You For Your Support! 🙏",
//       icon: (
//         <img
//           src="https://i.ibb.co/xKTF703L/pngtree-programmer-it-developer-png-image-13520483.png"
//           width={40}
//           height={40}
//           alt="Aceternity Logo"
//         />
//       ),
//       href: "https://mrabhi2k3.me",
//       target: "_blank",
//     },
//     {
//       title: "Donate via Paypal",
//       icon: <FaPaypal className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "https://donate.mrabhi2k3.me/paypal",
//     },
//     {
//       title: "Buy Me A Coffee",
//       icon: <FaCoffee className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "https://ko-fi.com/MrAbhi2k3",
//     },
//     {
//       title: "Telegram Stars",
//       icon: <RiTelegramLine className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
//       href: "https://t.me/DonateXRobot",
//     },
//   ];

//   return (
//     <div className="min-h-screen sm:text-center bg-dark flex flex-col items-center justify-center p-4">
//       {/* <BackgroundBeamsWithCollision className="flex flex-col items-center justify-center p-4 sm:z-10"> */}
//         <p className='font-sans text-white text-xl mt-8 sm:text-center'> Want to be My One of the Sponsors or Donor</p>
//       <h1 className="text-4xl text-white font-extrabold mb-8 mt-4 font-sans">Sponsor & Donate</h1>
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">

//         {/* UPI Section For QR and DeepLink with UPI:App */}
//         <BackgroundGradient className="rounded-[22px] max-w-sm p-4 sm:p-10 bg-white dark:bg-zinc-900">
//         <img
//           src={`https://i.ibb.co/ks6cRNcH/upi.png`}
//           alt="Alt Data"
//           height="400"
//           width="400"
//           className="object-contain"
//         />
//           <div className="flex flex-col items-center">
//             <h2 className="text-2xl text-white font-semibold mb-4">UPI</h2>
//             <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
//               Scan the QR code or use UPI ID to donate.
//             </p>
//             <button className="rounded-full w-full h-12 pl-4 pr-1 py-1 text-white flex items-center space-x-1 bg-black mt-4 text-xs font-bold font-sans dark:bg-zinc-800">
//               <a href='/upi'>
//               <span>Donate via UPI</span>
//                 </a>
//               <span className="bg-zinc-700 rounded-full w-10 h-10 text-[0.6rem] px-2 py-0 text-white">
//                 <FaRupeeSign className='text-xl mt-2'/>
//               </span>
//             </button>
//           </div>
//         </BackgroundGradient>

//         {/* Crypto Section */}
//         <BackgroundGradient className="rounded-[22px] max-w-sm p-4 sm:p-10 bg-white dark:bg-zinc-900">
//         <img
//           src={`https://i.ibb.co/JWCxVzg4/worldwide-coin-3d-icon-download-in-png-blend-fbx-gltf-file-formats-crypto-world-and-network-cryptocu.png`}
//           alt="Alt Data"
//           height="400"
//           width="400"
//           className="object-contain"
//         />
//           <div className="flex flex-col items-center">
//             <h2 className="text-2xl text-yellow-500 font-semibold mb-4">Crypto</h2>
//             <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
//               Send cryptocurrency to the provided wallet address.
//             </p>
//             <button className="rounded-full w-full h-12 pl-4 pr-1 py-1 text-white flex items-center space-x-1 bg-black mt-4 text-xs font-bold font-sans dark:bg-zinc-800">
//               <a href='/crypto'>
//               <span>Donate via Crypto</span>
//                 </a>
//               <span className="bg-zinc-700 w-10 h-10 rounded-full text-[0.6rem] px-2 py-0 text-white">
//                 <FaBtc className='text-xl mt-2'/>
//               </span>
//             </button>
//           </div>
//         </BackgroundGradient>

//         {/* PayPal Section */}
//         <BackgroundGradient className="rounded-[22px] max-w-sm p-4 sm:p-10 bg-white dark:bg-zinc-900">
//         <img
//           src={`https://i.ibb.co/20HmgXyn/Paypal-Icon-Transparent-File.png`}
//           alt="Alt Data"
//           height="400"
//           width="400"
//           className="object-contain"
//         />
//           <div className="flex flex-col items-center">
//             <h2 className="text-2xl text-blue-500 font-semibold mb-4">PayPal</h2>
//             <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
//               Use PayPal to make a internation sponsors.
//             </p>
//             <button className="rounded-full w-full h-12 pl-4 pr-1 py-1 text-white flex items-center space-x-1 bg-black mt-4 text-xs font-bold font-sans dark:bg-zinc-800">
//               <a href='/paypal'>
//               <span>Donate via PayPal</span>
//                 </a>
//               <span className="bg-zinc-700 w-10 h-10 rounded-full text-[0.6rem] px-2 py-0 text-white">
//                 <FaPaypal className='text-xl mt-2'/>
//               </span>
//             </button>
//           </div>
//         </BackgroundGradient>
//       </div>
//       <div className="mt-20 z-20">
//         <FloatingDock
//           mobileClassName="translate-y-20"
//           items={links}
//         />
//       </div>
//       {/* </BackgroundBeamsWithCollision> */}
//     </div>
//   );
// };

// export default SponsorPage;

"use client";


import React, { useState } from 'react';
import { FloatingDock } from '../ui/floating-dock';
import { 
    FaPaypal,
    FaBtc,
    FaRupeeSign,
    FaCoffee,
} from "react-icons/fa";
import { RiTelegramLine } from "react-icons/ri";
import { SiGithubsponsors } from "react-icons/si";
import { BackgroundGradient } from '../ui/background-gradient';
import { motion } from 'framer-motion';

const SponsorPage = () => {
  const [activePanel, setActivePanel] = useState(null);
  const [direction, setDirection] = useState(1);

  const links = [
    {
      title: "Donate via UPI",
      icon: <FaRupeeSign className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "/upi",
    },
    {
      title: "Donate via GitHub Sponsors",
      icon: <SiGithubsponsors className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "https://github.com/sponsors/MrAbhi2k3",
    },
    {
      title: "Donate via Bitcoin",
      icon: <FaBtc className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "/crypto",
    },
    {
      title: "Thank You For Your Support! 🙏",
      icon: (
        <img
          src="https://i.ibb.co/xKTF703L/pngtree-programmer-it-developer-png-image-13520483.png"
          width={40}
          height={40}
          alt="Aceternity Logo"
        />
      ),
      href: "https://mrabhi2k3.me",
      target: "_blank",
    },
    {
      title: "Donate via Paypal",
      icon: <FaPaypal className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "https://donate.mrabhi2k3.me/paypal",
    },
    {
      title: "Buy Me A Coffee",
      icon: <FaCoffee className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "https://ko-fi.com/MrAbhi2k3",
    },
    {
      title: "Telegram Stars",
      icon: <RiTelegramLine className="h-full w-full text-neutral-500 dark:text-neutral-300" />,
      href: "https://t.me/DonateXRobot",
    },
  ];

  const panels = [
    {
      id: 'upi',
      title: "UPI",
      color: "text-white",
      icon: <FaRupeeSign className="text-xl mt-2" />,
      image: "https://i.ibb.co/ks6cRNcH/upi.png",
      description: "Scan the QR code or use UPI ID to donate.",
      href: "/upi"
    },
    {
      id: 'crypto',
      title: "Crypto",
      color: "text-yellow-500",
      icon: <FaBtc className="text-xl mt-2" />,
      image: "https://i.ibb.co/JWCxVzg4/worldwide-coin-3d-icon-download-in-png-blend-fbx-gltf-file-formats-crypto-world-and-network-cryptocu.png",
      description: "Send cryptocurrency to the provided wallet address.",
      href: "/crypto"
    },
    {
      id: 'paypal',
      title: "PayPal",
      color: "text-blue-500",
      icon: <FaPaypal className="text-xl mt-2" />,
      image: "https://i.ibb.co/20HmgXyn/Paypal-Icon-Transparent-File.png",
      description: "Use PayPal to make a international sponsors.",
      href: "/paypal"
    }
  ];

  const handlePanelClick = (panelId) => {
    setDirection(panelId > activePanel ? 1 : -1);
    setActivePanel(panelId === activePanel ? null : panelId);
  };

  return (
    <div className="min-h-screen bg-dark flex flex-col items-center justify-center p-4 overflow-hidden">
      <div className="w-full max-w-6xl px-4">
        <p className='font-sans text-white text-xl mt-8 text-center'>Want to be My One of the Sponsors or Donor</p>
        <h1 className="text-4xl text-white font-extrabold mb-8 mt-4 text-center font-sans">Sponsor & Donate</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
          {panels.map((panel) => (
            <motion.div 
              key={panel.id}
              whileHover={{ y: -5 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <BackgroundGradient className="rounded-[22px] h-full p-4 sm:p-10 bg-white dark:bg-zinc-900 cursor-pointer">
                <div onClick={() => handlePanelClick(panel.id)}>
                  <img
                    src={panel.image}
                    alt={panel.title}
                    height="400"
                    width="400"
                    className="object-contain mx-auto"
                  />
                  <div className="flex flex-col items-center">
                    <h2 className={`text-2xl ${panel.color} font-semibold mb-4`}>{panel.title}</h2>
                    <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4 text-center">
                      {panel.description}
                    </p>
                  </div>
                </div>

                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{
                    height: activePanel === panel.id ? "auto" : 0,
                    opacity: activePanel === panel.id ? 1 : 0
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <motion.div
                    initial={{ x: 100 * direction }}
                    animate={{ x: 0 }}
                    exit={{ x: -100 * direction }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  >
                    <button className="rounded-full w-full h-12 pl-4 pr-1 py-1 text-white flex items-center justify-between bg-black mt-4 text-sm font-bold font-sans dark:bg-zinc-800">
                      <a href={panel.href} className="flex items-center justify-between w-full">
                        <span>Donate via {panel.title}</span>
                        <span className="bg-zinc-700 rounded-full w-10 h-10 flex items-center justify-center">
                          {panel.icon}
                        </span>
                      </a>
                    </button>
                  </motion.div>
                </motion.div>
              </BackgroundGradient>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="mt-20 z-20">
        <FloatingDock
          mobileClassName="translate-y-20"
          items={links}
        />
      </div>
    </div>
  );
};

export default SponsorPage;